define('components/Affix',[
    "jquery",
    "underscore", 
    "utilities",
    "logging"
], function ($, _, utilities, logging) {
    var _ModuleName = "Affix";

    var _config = {
        scrollThrottle: 1e3,
        navigationOffset: 75,
        affixClass: 'path-affix'
    };

    function Affix(scope) {
        "use strict";

        // Affixed element
        var $affixElem = $(scope);

        // Find containing row element
        var $row = $affixElem;
        while ($row.length && $row.parent().length && !$row.hasClass("row"))
            $row = $row.parent();

        // Find Delta offset within column based on elements not affixed
        var $staticElems = $affixElem.parent().children();
        var topDelta = 0;
        for(var i = 0; i < $staticElems.length; i++) {
            var $element = $($staticElems[i]);
            if($element.hasClass(_config.affixClass)) break;
            topDelta += $element.outerHeight(false);
        }
        if(topDelta) {
            ;
        }

        // Only affix the element if the containing row is found
        if ($row.length == 0 || !$row.hasClass("row")) {
            logging.error("ERROR: Failed to affix element. Could not find parent row element.", _ModuleName);
            return null;
        }

        // Only affix the element if the containing row is at least 1.5 times its own height
        if ($row.outerHeight(false) < 1.5 * $affixElem.height()) {
            logging.warn("WARNING: Element not affixed because parent row is too small.", _ModuleName);
            return null;
        }

        // Cache a few dom objects for performance purposes
        var $window = $(window);
        var $document = $(document);
        var $body = $(document.body);

        // Calculate Offsets
        var skinOffset = $body.hasClass("enable-skin") ? 120 : 0;
        var topOffset = $row.offset().top + topDelta - skinOffset - _config.navigationOffset;
        var bottomOffset = $document.height() - ($row.offset().top + $row.outerHeight(false));

        // Original Width to force it to stick
        var origWidth = $affixElem.width();

        // Initialize the Affix functionality
        $affixElem.affix({
            offset: {
                top: function () {
                    return (this.top = topOffset);
                },
                bottom: function () {
                    return (this.bottom = bottomOffset);
                }
            }
        });

        // Fix positioning when element has padding in document
        $affixElem.on('affixed.bs.affix', function () {
            var parentWidth = $affixElem.parent().width();
            var affixWidth = $affixElem.width();

            var padding = (parentWidth - affixWidth) / 2;

            $(this).css({
                'padding-left': padding,
                'padding-right': padding,
                'width': origWidth
            })
        });

        // Remove padding fix when no longer affixed
        $affixElem.on('affixed-top.bs.affix', function () {
            $(this).removeAttr('style');
        });

        var lastScrollTop = 0;
        // Set up Affix updates on Window Scroll
        var throttled = _.throttle(function () {
            var st = $window.scrollTop();
            skinOffset = $body.hasClass("enable-skin") && (st > lastScrollTop) ? 120 : 0;

            // Recalculate Top Delta
            topDelta = 0;
            for(var i = 0; i < $staticElems.length; i++) {
                var $element = $($staticElems[i]);
                if($element.hasClass(_config.affixClass)) break;
                topDelta += $element.outerHeight(false);
            }

            // Recalculate offsets
            topOffset = $row.offset().top + topDelta - skinOffset - _config.navigationOffset;
            bottomOffset = $(document).height() - ($row.offset().top + $row.outerHeight(false));

            if (typeof $affixElem.data('bs.affix') != 'undefined') {
                $affixElem.data('bs.affix').options.offset.bottom = bottomOffset;
                $affixElem.data('bs.affix').options.offset.top = topOffset;
            }

            lastScrollTop = st;
        }, _config.scrollThrottle);
        $window.scroll(throttled);

        ;
    }
 

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            // Do not initialize the module if we are on a mobile device
            if (utilities.IsMobile() === true) {
                ;
                return null;
            }

            ;
            return new Affix(args.scope);
        }
    }
});



